import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { Checkbox, Input, message, Modal } from 'antd';
import { simplePost, simplePut, makeApiRequestAndHandleError } from 'common/utils/http';
import { SearchPaneResultsContext } from 'common/contexts';
import { SelectedUsersContext } from 'pages/UserPage/context';

const SpecialRecordModal = ({ isOpen, toggle }) => {
  const [checkedWarning, setCheckedWarning] = useState(false);
  const [name, setName] = useState('');

  const { setSelectedUsers } = useContext(SelectedUsersContext);
  const { setSortedSearchResults } = useContext(SearchPaneResultsContext);

  const resetModal = () => {
    setName('');
    setCheckedWarning(false);
    toggle(false);
  };

  const handleCancel = () => {
    resetModal();
  };

  const handleAddSpecialRecord = async () => {
    if (checkedWarning) {
      makeApiRequestAndHandleError(async () => {
        const newUser = await simplePost('/api/v1/people');
        await simplePut(`/api/v1/people/${newUser.user_id}/attributes?name=${name}`);
        resetModal();
        setSelectedUsers([newUser.user_id]);

        // Set special user data to be handled properly by the SearchPane
        const specialUser = {
          person_id: newUser.user_id,
          genres: [
            {
              name: 'user-info',
              sections: [
                {
                  name: 'personal',
                  attribute_types: [
                    {
                      name: 'name',
                      attributes: [
                        {
                          value: name,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        };
        setSortedSearchResults([specialUser]);
      });
    } else {
      message.error('Please acknowledge warning by clicking checkbox.');
    }
  };

  return (
    <Modal
      okButtonProps={{ disabled: !checkedWarning }}
      okText="Create User"
      onCancel={handleCancel}
      onOk={handleAddSpecialRecord}
      open={isOpen}
      title="Add Special Record"
    >
      <div>
        NOTE: this method of adding users should only be used in exceptional circumstances where the
        user does not have a cell phone number, such as adding an infant or a service account.
        Otherwise, please use the normal &quot;Add Contact&quot; page.
      </div>
      <div style={{ margin: '10px 0' }}>
        <Checkbox checked={checkedWarning} onChange={e => setCheckedWarning(e.target.checked)}>
          I confirm this user does not have a cell phone
        </Checkbox>
      </div>
      {checkedWarning && (
        <div>
          <Input onChange={e => setName(e.target.value)} value={name} />
        </div>
      )}
    </Modal>
  );
};

SpecialRecordModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default SpecialRecordModal;
